import { PlusIcon, SettingsIcon } from "@xola/icons";
import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { canViewCustomersSettings, useCanExportCustomers } from "../../stores/globalStore";
import { Page } from "../Page";
import { SecondaryButton } from "@/components/Common/SecondaryButton";
import { ContactList } from "@/components/Customers/Contacts/ContactList";
import { ContactSearch } from "@/components/Customers/Contacts/ContactSearch";
import { ColumnLayout } from "@/components/Layout/ColumnLayout";
import { EmbeddedAppTriggerLocation } from "@/embeddedApps/EmbeddedAppTriggerLocation";

export const ContactPage = () => {
    const history = useHistory();
    const { customerId } = useParams<{ customerId?: string }>();
    const [search, setSearch] = useState("");
    const canExportCustomers = useCanExportCustomers();

    const handleClick = () => {
        history.push("/customers/contacts");
    };

    const handleRedirect = () => {
        history.push("/reports/customReports/new/?object=CustomersReport");
    };

    const handleSettingsClick = () => {
        history.push("/customers/settings");
    };

    return (
        <Page title="Contacts">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb>
                        <Breadcrumb.Item>Customers</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleClick}>Contacts</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>

                    <ContactSearch onSearchText={setSearch} />
                    <EmbeddedAppTriggerLocation id="customers.contacts.headerBar" />
                    {customerId && (
                        <EmbeddedAppTriggerLocation
                            id="customers.contacts.detail.headerBar"
                            context={{ customers: [{ id: customerId }] }}
                        />
                    )}
                    <div className="flex space-x-3">
                        {canViewCustomersSettings() && (
                            <SecondaryButton icon={<SettingsIcon />} onClick={handleSettingsClick}>
                                Settings
                            </SecondaryButton>
                        )}

                        {canExportCustomers && (
                            <SecondaryButton
                                icon={<PlusIcon />}
                                data-testid="export-customers-button"
                                onClick={handleRedirect}
                            >
                                Export Customers
                            </SecondaryButton>
                        )}
                    </div>
                </HeaderToolbar>

                <ColumnLayout.Fill>{(height) => <ContactList height={height} search={search} />}</ColumnLayout.Fill>
            </ColumnLayout>
        </Page>
    );
};
